import { useEffect, useState } from 'preact/hooks';

import getDeviceId, { getDeviceIdSync } from '@/helpers/getDeviceId';

const useDeviceId = () => {
  const [deviceId, setDeviceId] = useState<string | null>(() => getDeviceIdSync());

  useEffect(() => {
    if (deviceId) {
      return undefined;
    }

    let unmounted = false;
    const get = async () => {
      const id = await getDeviceId();
      if (!unmounted) {
        setDeviceId(id);
      }
    };
    get();
    return () => {
      unmounted = true;
    };
  }, [deviceId]);

  return deviceId;
};

export default useDeviceId;
